import React, { PureComponent } from "react";
import NetsPaymentModule from "../../components/NetsPaymentModule";

export default class PaymentGateway extends PureComponent {
    constructor(props) {
        super(props);
        const paymentamount = this.props.location.state
            ? this.props.location.state.totalAmount
            : null;
        const request = this.props.location.state
            ? this.props.location.state.requestForm
            : null;
        //console.log(paymentamount);
        const isInvPayment = this.props.location.state
            ? this.props.location.state.isInvoicePayment === true
            : null;
        this.state = { totalAmount: paymentamount, requestForm: request, isInvoicePayment: isInvPayment };
    }

    render() {
        return (
            <div>
                <NetsPaymentModule txnAmount={this.state.totalAmount} requestForm={this.state.requestForm} isInvoicePayment={this.state.isInvoicePayment} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/main/PaymentGateway.js